
import { Buffer } from "buffer";
import process from "process/browser";

(window as any).Buffer = Buffer;

(window as any).process = process;
